import { createAction } from '@mendeley-internal/lib-js-redux-actions';
import api from '../services/api/request';

export const getEntitlement = createAction(
  'GET_ENTITLEMENT',
  documentId => api
    .post('entitlements', documentId)
    .batch(requests => ({
      data: requests.map(request => request.data)
    }))
    .setCritical(false),
  documentId => ({ documentId }),
);



// WEBPACK FOOTER //
// ./src/universal/ui/actions/entitlements.js